import React, { useState, useEffect } from "react";
import Image from "../../../assets/img/ShiproneLogo.png";
import { useDispatch, useSelector } from "react-redux";
import { getMyDashboardTabWidgets } from "../../../redux/actions/analytics";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";

// Components
import StatusCard from "../Components/StatusCard";
import BarGraph from "../Graphs/BarGraph";
import SingleBarGraph from "../Graphs/SingleBarGraph";
import PieChart from "../Graphs/PieChart";
import AreaGraph from "../Graphs/AreaGraph";
import HorizontalStackedBar from "../Graphs/HorizontalStackedBar";
import ToDoBacklogTable from "../Components/ToDoBacklogTable";
import CustomerTable from "../Components/CustomerTable";
import CollaboratorTable from "../Components/CollaboratorTable";
import UserTable from "../Components/UserTable";

// CSS constants
const cardCss =
  "bg-[--bg-color-50] h-[100px] rounded-md flex items-center px-4 relative";
const graphAndTableCss =
  "bg-[--bg-color-50] h-[340px] rounded-md relative px-4 py-3 col-span-2";
const pieChartCss =
  "bg-[--bg-color-50] h-[340px] rounded-md relative px-4 py-3";

function MyDashboard() {
  
  const [update, setUpdate] = useState(1);
  const [loader, setLoader] = useState(true);
  const [dateRange, setDateRange] = useState([]);

  const { myDashboardWidgets } = useSelector((state) => state.analytics);
  const { color_palettes } = useSelector((state) => state.palettes);
  const dispatch = useDispatch();

  // Widgets Constant
  const widgets = [
    {
      widgetName: "todos_pending",
      css: cardCss,
      type: "card",
      title: "To Dos",
      status: "Pending",
      statusColor: color_palettes[500],
    },
    {
      widgetName: "todos_overdue",
      css: cardCss,
      type: "card",
      title: "To Dos",
      status: "Overdue",
      statusColor: "#EB5757",
    },
    {
      widgetName: "bookings_ongoing",
      css: cardCss,
      type: "card",
      title: "Bookings",
      status: "Ongoing",
      statusColor: color_palettes[500],
    },
    {
      widgetName: "bookings_completed",
      css: cardCss,
      type: "card",
      title: "Bookings",
      status: "Completed",
      statusColor: color_palettes[500],
    },
    {
      widgetName: "average_delayed_todo",
      css: cardCss,
      type: "card",
      title: "Average To Dos Delayed",
      status: "Delayed",
      statusColor: "#EB5757",
    },
    {
      widgetName: "average_delayed_todos",
      css: cardCss,
      type: "card",
      title: "Average To Dos Delayed",
      status: "Completed With Delay",
      statusColor: "#EB5757",
    },
    {
      widgetName: "todos_assigned",
      css: cardCss,
      type: "card",
      title: "To Dos Assigned",
      statusColor: color_palettes[500],
    },
    {
      widgetName: "total_bookings",
      css: cardCss,
      type: "card",
      title: "Total Booking",
      statusColor: color_palettes[500],
    },
    {
      widgetName: "units_handled",
      css: cardCss,
      type: "card",
      title: "Units Handled",
      statusColor: color_palettes[500],
    },
    {
      widgetName: "todo_performance_stakeholder",
      css: cardCss,
      type: "Horizontal Stacked",
      title: "To Do Assignment per Stakeholder",
    },
    {
      widgetName: "weekly_pending_todos",
      css: graphAndTableCss,
      type: "bar graph",
      title: "Pending To Dos",
    },
    {
      widgetName: "weekly_assigned_todos",
      css: graphAndTableCss,
      type: "simplebar graph",
      title: "Assign To Dos",
    },
    {
      widgetName: "todos_weekly_backlog",
      css: graphAndTableCss,
      type: "table",
      title: "To Do Backlog",
    },
    {
      widgetName: "recent_customers",
      css: graphAndTableCss,
      type: "table",
      title: "Customers",
    },
    {
      widgetName: "recent_collaborator",
      css: graphAndTableCss,
      type: "table",
      title: "Collaborators",
    },
    {
      widgetName: "recent_users",
      css: graphAndTableCss,
      type: "table",
      title: "Users",
    },
    {
      widgetName: "weekly_bookings",
      css: graphAndTableCss,
      type: "area graph",
      title: "Bookings",
    },
    {
      widgetName: "booking_templates_used",
      css: pieChartCss,
      type: "pie graph",
      title: "Booking Templates Used",
    },
    {
      widgetName: "worflows_used",
      css: pieChartCss,
      type: "pie graph",
      title: "Workflow Used",
    },
    {
      widgetName: "percentage_based_on_assigned_todos",
      css: pieChartCss,
      type: "pie graph",
      title: "Assigned To Dos Per Collaborator",
    },
    {
      widgetName: "monthly_container",
      css: graphAndTableCss,
      type: "bar graph",
      title: "Container Volume (Monthly)",
    },
    {
      widgetName: "container_volume",
      css: pieChartCss,
      type: "pie graph",
      title: "Container Volume (Carrier-Wise)",
    },
  ];

  const getWidgets = (startDate, endDate) => {
    const request = {
      onSuccess: () => {},
      onError: () => {},
    };
    dispatch(getMyDashboardTabWidgets(startDate, endDate, request));
  };

  useEffect(() => {
    if (dateRange.length === 2) {
      getWidgets(
        moment(dateRange[0]).format("YYYY-MM-DD"),
        moment(dateRange[1]).format("YYYY-MM-DD")
      );
    } else {
      getWidgets();
    }
  }, [dateRange, update]);

  const renderTable = (item, widgetTypeAndStyle) => {
    const userType = widgetTypeAndStyle.title;
    switch (userType) {
      case "Customers": {
        return (
          <CustomerTable
            title={
              <div className="flex">
                <span className="text-[#6B7280] font-normal capitalize">
                  {item.module_name}&nbsp;
                </span>
                <span class="fa-solid fa-angle-right text-sm font-normal"></span>
                &nbsp;
                <div
                  title={widgetTypeAndStyle.title}
                  className="max-w-full truncate"
                >
                  {widgetTypeAndStyle.title}
                </div>
              </div>
            }
            menu={["Delete"]}
            id={item}
            data={item.data}
            isDisable={false}
            setUpdate={setUpdate}
            update={update}
            tab="my-dashboard"
          />
        );
      }

      case "Collaborators": {
        return (
          <CollaboratorTable
            title={
              <div className="flex">
                <span className="text-[#6B7280] font-normal capitalize">
                  {item.module_name}&nbsp;
                </span>
                <span class="fa-solid fa-angle-right text-sm font-normal"></span>
                &nbsp;
                <div
                  title={widgetTypeAndStyle.title}
                  className="max-w-full truncate"
                >
                  {widgetTypeAndStyle.title}
                </div>
              </div>
            }
            menu={["Delete"]}
            id={item}
            data={item.data}
            isDisable={false}
            setUpdate={setUpdate}
            update={update}
            tab="my-dashboard"
          />
        );
      }

      case "Users": {
        return (
          <UserTable
            title={
              <div className="flex">
                <span className="text-[#6B7280] font-normal capitalize">
                  {item.module_name}&nbsp;
                </span>
                <span class="fa-solid fa-angle-right text-sm font-normal"></span>
                &nbsp;
                <div
                  title={widgetTypeAndStyle.title}
                  className="max-w-full truncate"
                >
                  {widgetTypeAndStyle.title}
                </div>
              </div>
            }
            menu={["Delete"]}
            id={item}
            data={item.data}
            isDisable={false}
            setUpdate={setUpdate}
            update={update}
            tab="my-dashboard"
          />
        );
      }

      case "To Do Backlog": {
        return (
          <ToDoBacklogTable
            title={
              <div className="flex">
                <span className="text-[#6B7280] font-normal capitalize">
                  {item.module_name}&nbsp;
                </span>
                <span class="fa-solid fa-angle-right text-sm font-normal"></span>
                &nbsp;
                <div
                  title={widgetTypeAndStyle.title}
                  className="max-w-full truncate"
                >
                  {widgetTypeAndStyle.title}
                </div>
              </div>
            }
            menu={["Delete"]}
            id={item}
            data={item.data}
            isDisable={false}
            setUpdate={setUpdate}
            update={update}
            tab="my-dashboard"
          />
        );
      }

      default: {
        return null;
      }
    }
  };

  const showWidgets = (item, widgetTypeAndStyle) => {
    const type = widgetTypeAndStyle?.type;

    switch (type) {
      case "card": {
        return (
          <div className={widgetTypeAndStyle.css}>
            <StatusCard
              id={item}
              title={
                <div className="flex">
                  <span className="text-[#6B7280] font-normal capitalize">
                    {item.module_name}&nbsp;
                  </span>
                  <span class="fa-solid fa-angle-right text-sm font-normal"></span>
                  &nbsp;
                  <div
                    title={widgetTypeAndStyle.title}
                    className="max-w-full truncate"
                  >
                    {widgetTypeAndStyle.title}
                  </div>
                </div>
              }
              status={
                widgetTypeAndStyle.status ? widgetTypeAndStyle.status : null
              }
              statusColor={widgetTypeAndStyle.statusColor}
              menu={["Delete"]}
              value={
                item.analytic_widget_name === "average_delayed_todos" ||
                item.analytic_widget_name === "average_delayed_todo"
                  ? `${item.data}%`
                  : item.data.count
              }
              isDisable={false}
              setUpdate={setUpdate}
              update={update}
              tab="my-dashboard"
            />
          </div>
        );
      }

      case "bar graph": {
        return (
          <div className={widgetTypeAndStyle.css}>
            <BarGraph
              title={
                <div className="flex">
                  <span className="text-[#6B7280] font-normal capitalize">
                    {item.module_name}&nbsp;
                  </span>
                  <span class="fa-solid fa-angle-right text-sm font-normal"></span>
                  &nbsp;
                  <div
                    title={widgetTypeAndStyle.title}
                    className="max-w-full truncate"
                  >
                    {widgetTypeAndStyle.title}
                  </div>
                </div>
              }
              id={item}
              menu={["Delete"]}
              data={item.data}
              isDisable={false}
              setUpdate={setUpdate}
              update={update}
              tab="my-dashboard"
            />
          </div>
        );
      }

      case "pie graph": {
        return (
          <div className={widgetTypeAndStyle.css}>
            <PieChart
              title={
                <div className="flex">
                  <span className="text-[#6B7280] font-normal capitalize">
                    {item.module_name}&nbsp;
                  </span>
                  <span class="fa-solid fa-angle-right text-sm font-normal"></span>
                  &nbsp;
                  <div
                    title={widgetTypeAndStyle.title}
                    className="max-w-full truncate"
                  >
                    {widgetTypeAndStyle.title}
                  </div>
                </div>
              }
              menu={["Delete"]}
              id={item}
              data={item.data}
              isDisable={false}
              setUpdate={setUpdate}
              update={update}
              tab="my-dashboard"
            />
          </div>
        );
      }

      case "area graph": {
        return (
          <div className={widgetTypeAndStyle.css}>
            <AreaGraph
              title={
                <div className="flex">
                  <span className="text-[#6B7280] font-normal capitalize">
                    {item.module_name}&nbsp;
                  </span>
                  <span class="fa-solid fa-angle-right text-sm font-normal"></span>
                  &nbsp;
                  <div
                    title={widgetTypeAndStyle.title}
                    className="max-w-full truncate"
                  >
                    {widgetTypeAndStyle.title}
                  </div>
                </div>
              }
              id={item}
              data={item.data}
              menu={["Delete"]}
              isDisable={false}
              setUpdate={setUpdate}
              update={update}
              tab="my-dashboard"
            />
          </div>
        );
      }

      case "table": {
        return (
          <div className={widgetTypeAndStyle.css}>
            {renderTable(item, widgetTypeAndStyle)}
          </div>
        );
      }

      case "Horizontal Stacked": {
        return (
          <div className={widgetTypeAndStyle.css}>
            <HorizontalStackedBar
              title={
                <div className="flex">
                  <span className="text-[#6B7280] font-normal capitalize">
                    {item.module_name}&nbsp;
                  </span>
                  <span class="fa-solid fa-angle-right text-sm font-normal"></span>
                  &nbsp;
                  <div
                    title={widgetTypeAndStyle.title}
                    className="max-w-full truncate"
                  >
                    {widgetTypeAndStyle.title}
                  </div>
                </div>
              }
              id={item}
              menu={["Delete"]}
              value={item.data}
              isDisable={false}
              setUpdate={setUpdate}
              update={update}
              tab="my-dashboard"
            />
          </div>
        );
      }

      case "simplebar graph": {
        return (
          <div className={widgetTypeAndStyle.css}>
            <SingleBarGraph
              title={
                <div className="flex">
                  <span className="text-[#6B7280] font-normal capitalize">
                    {item.module_name}&nbsp;
                  </span>
                  <span class="fa-solid fa-angle-right text-sm font-normal"></span>
                  &nbsp;
                  <div
                    title={widgetTypeAndStyle.title}
                    className="max-w-full truncate"
                  >
                    {widgetTypeAndStyle.title}
                  </div>
                </div>
              }
              id={item}
              menu={["Delete"]}
              data={item.data}
              isDisable={false}
              setUpdate={setUpdate}
              update={update}
              tab="my-dashboard"
            />
          </div>
        );
      }

      default:
        break;
    }
  };

  return (
    <div>
      <div>
        {myDashboardWidgets.length > 0 ? (
          <div className="py-2 space-y-4 jus">
            {/* Datepicker Filter and Cards */}
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              <div className="col-span-2 h-[50px] bg-[--bg-color-50] px-4 rounded-md flex items-center">
                <div className="w-1/2 flex items-center">
                  <h4 className="text-sm font-semibold text-[#313439] leading-5 grow">
                    Filters
                  </h4>
                  <div className="relative">
                    <Flatpickr
                      data-enable-time
                      options={{
                        altFormat: "j M, Y",
                        dateFormat: "Y-m-d H:i",
                        time_24hr: false,
                        disableMobile: true,
                        enableTime: false,
                        altInput: true,
                        mode: "range",
                      }}
                      placeholder="From - To Date"
                      className="form-input !h-7 relative cursor-pointer"
                      onChange={(e) => setDateRange(e)}
                      value={
                        dateRange.length > 0
                          ? dateRange
                          : [
                              moment()
                                .subtract(3, "months")
                                .format("YYYY-MM-DD"),
                              moment().format("YYYY-MM-DD"),
                            ]
                      }
                    />
                    {dateRange.length === 0 && (
                      <button
                        type="reset"
                        className="hidden absolute right-3 top-1/2 transform -translate-y-1/2 space-x-2 bg-[#fff] z-60"
                      >
                        <span className="fa-thin fa-pipe text-[#737373] text-xs"></span>
                        <span className="fa-solid fa-chevron-down text-[#737373] text-xs"></span>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
              {myDashboardWidgets.map((item, index) => {
                const widgetTypeAndStyle = widgets.find(
                  (element) => element.widgetName === item.analytic_widget_name
                );
                return showWidgets(item, widgetTypeAndStyle);
              })}
            </div>
          </div>
        ) : (
          <div
            className="h-screen flex justify-center items-center"
            style={{ height: "calc(100vh - 138px" }}
          >
            <div
              className="w-2/3 h-2/3 bg-center bg-opacity-25 flex justify-center items-center"
              style={{
                backgroundImage:
                  "linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url(" +
                  Image +
                  ")",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="text-center">
                <h4 className="text-[15px] leading-7 tracking-tight font-bold text-[#1E293B] ">
                  Your dashboard is currently empty.
                </h4>
                <p className="text-[15px] leading-7 tracking-tight text-[#1E293B]">
                  No widgets have been added yet.
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default MyDashboard;
